import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { FollowType } from '../../utils/backend-api/follow';
import TopicFollowAndTagModal from '../Topic/TopicFollowAndTagModal';
import FollowButton from '../shared/FollowButton';
import { SearchPageProps } from './index';
import styles from './styles.module.scss';

interface SearchHeaderProps
  extends Omit<SearchPageProps, 'articleContent' | 'page' | 'query' | 'scope' | 'topEntities'> {
  isSignedIn: boolean;
}

const SearchHeader = ({
  customBlurb,
  followCount,
  followers,
  followStatus,
  isSignedIn,
  matchingEntity,
  title,
  topicOrAuthorLink,
  topRelatedEntities,
}: SearchHeaderProps) => {
  const topicOrAuthorLinkText =
    topicOrAuthorLink && topicOrAuthorLink.split('/')[1] === 'u'
      ? 'Author Profile'
      : 'The Information Topic';

  return (
    <div className={clsx(styles.titleSection, 'row')}>
      <div className="col-md-8 col-xs-12">
        <div className={styles.searchPageHeader}>
          <div className={styles.searchPageTitle}>
            {title}
            {matchingEntity && (
              <FollowButton
                followStatus={followStatus}
                followeeId={matchingEntity.id}
                followType={FollowType.Entity}
                showSubscribeModal={!isSignedIn}
                name={matchingEntity.name}
              />
            )}
          </div>
          {topicOrAuthorLink && (
            <div className={styles.topicOrAuthorLink}>
              {topicOrAuthorLinkText}: <a href={topicOrAuthorLink}>{title}</a>
            </div>
          )}
          {customBlurb && <div className={styles.customBlurb}>{ReactHtmlParser(customBlurb)}</div>}
        </div>
      </div>
      {matchingEntity && (followCount > 0 || topRelatedEntities?.length > 0) && (
        <div className="col-md-4 col-xs-12">
          <TopicFollowAndTagModal
            totalFollowers={followCount}
            followers={followers}
            relatedTopics={topRelatedEntities || []}
          />
        </div>
      )}
    </div>
  );
};

export default SearchHeader;
